const message = {
  englishTextOne: "Professional Option Traders' Tool Kit",
  englishTextTwo: "HomePage",
  englishTextThree: "Block Trading",
  englishTextFour: "Newcomers'Guide",
  englishTextFive: "Contact Us",
  englishTextSix: "Twitter",
  englishTextSeven: "Telegram (CN)",
  englishTextEight: "Telegram (EN)",
  englishTextNine: "About Us",
  englishTextTen: "AMBASSADOR PROGRAM",
  englishTextEleven: "Connect",
  englishTextTwelve: "TRADING WEBSITE",
  englishTextThirteen: "One click delta hedge",
  englishTextFourteen: "One click chase orders",
  englishTextFifteen: "Open orders sorting",
  AutoLendingTool: "The Auto Lending Tool",
  englishTextSixteen: "Customize columns",
  englishTextSeventeen: "POSITION VISUALIZATION",
  englishTextEighteen: "PnL Surface View",
  englishTextNineteen: "Greeks Surface View",
  englishTextTwenty: "Maintenance Margin Stress Test",
  englishTextTwentyOne: "PnL Heatmap",
  englishTextTwentyTwo: "Position Visualization",
  englishTextTwentyFour: "DATA LAB",
  englishTextTwentyFive: "IV/HV/VRP data",
  englishTextTwentySix: "Open Interest Data",
  englishTextTwentySeven: "Option Flow Data",
  englishTextTwentyEight: "IV Skew/Surface",
  dataLabDesc06: "Max Pain",
  englishTextTwentyNine: "PLAY BACK",
  playBackDesc01: "Replay recent options market activity",
  playBackDesc02: "Review how IV moved step-by-step",
  englishTextThirty: "ADVANCED TRADING TOOLS",
  englishTextThirty02: "Advanced Trading Tools",
  advanceToolsDesc01: "Auto DDH",
  advancedToolsDesc02: "Maker Assistant",
  advancedToolsDesc03: "Future Swap",
  advancedToolsDesc04: "Auto Synthetic Delivery",
  englishTextThirtyOne: "Terms of Service",
  englishTextThirtyTwo: "Deribit",
  englishTextThirtyThree: "BIT",
  trade: 'Trade',
  baseTrade: 'Screen Trading',
  socialTrading: 'Social Trading',
  joinTg: 'Join & discuss with the best options traders',
  relatedProducts: 'Our Products',
  whyOptions: 'WHY CRYPTO OPTIONS?',
  whyOptionsDesc01: 'Super high leverage upto 2,000x without risk of forced liquidation (standard margin buy options only);',
  whyOptionsDesc02: 'Effective portfolio hedge while reserve the potential of upsides;',
  whyOptionsDesc03: 'Best yield tool even in bear market;',
  whyOptionsDesc04: 'New trading dimension of volatility. Straddle, strangle, butterfly, and options trading with active delta hedge;',
  feature: 'POPULAR FEATURES',
  startDate: 'Started From',
  runningTime: 'Safe Running Time',
  days: 'days',
  backed: 'BACKED BY THE BEST',
  subtitle: 'ONE unified UI for different exchanges',
  officialWebsite: 'Official Website',
  lengTools: 'LENDING FACILITY',
  lengToolsDesc01: 'Variety Cryptocurrency Options',
  lengToolsDesc02: 'Flexible Loan Duration',
  lengToolsDesc03: 'Automatic Matching for Loan Transactions',
  lengToolsDesc04: 'High Security and Transparency',
  lengToolsDesc05: 'Good Liquidity and Market Depth',
  userProtocolTitle: 'Greeks.live Terms of Service',
  termsOfServiceAutoDDHContentL: '<ul><li>We provide web trading, Advanced Trading Tools, Smart Trading, and live trading functions</li><li>Our servers will process your position information to facilitate trading</li><li>We maintain the application on a best-efforts basis but are not liable for any bugs or defects</li><li>Any risks from using the application or crypto exchange downtime are solely your responsibility</li></ul>',
  termsOfServiceAPIKeyContentL: '<p>When you use API keys, ensure that they are kept secure during both storage and transmission. Publicly exposing your credentials can result in your account being compromised, which could lead to unexpected charges on your account. To help keep your API keys secure, follow these best practices:</p><li>We recommend to set up API key IP Whitelist. By adding IP Whitelist, you can reduce the impact of a compromised API key.</li><li>Delete unneeded API keys to minimize exposure to attacks.</li><li>Regenerate your API keys periodically.</li><p>Greeks.live and its applications donot store any of your API keys info. You are solely responsible to keep your API keys safe during usage. </p>',
  advanceToolsTips: 'Provides greater flexibility and risk management capabilities.',
  learnMoreDatalab: 'Learn more about Greeks.live Data Lab',
  learnMorePlayback: 'Learn more about Greeks.live Play Back',
  downloadApp: 'Download APP',
  tips: 'Tips',
  copySuccess: 'Copying the download link succeeded',
  download: 'Download',
  openInBrowser: 'Please open it with browser',
  oldVer2: 'Legacy',
  termsContent: {
    introduction: 'Introduction',
    termsIntroContent: '<p>Thank you for choosing Greeks.live services. This combined agreement includes our Terms of Service and Privacy Policy. Please read this document carefully as it explains our services, your rights and responsibilities, and how we protect your information.</p>',
    services: 'Services',
    webTradingServices: 'Web Trading Services and Advanced Trading Tools',
    webTradingServicesContent:  `
      <ul class="ol">
      <li>We provide web trading, Advanced Trading Tools, Smart Trading, and live trading functions</li>
      <li>Our servers will process your position information to facilitate trading</li>
      <li>We maintain the application on a best-efforts basis but are not liable for any bugs or defects</li>
      <li>Any risks from using the application or crypto exchange downtime are solely your responsibility</li>
      </ul>`,
    rfqServices: 'RFQ Trading Services',
    rfqServicesContent: `
      <ul class="ol">
        <li>RFQ trading refers to cryptocurrency trading with a single transaction value greater than or equal to 25 BTC or 250 ETH.</li>
        <li>Users can quote or inquire about RFQ trade orders on the platform.</li>
        <li>The platform will search for suitable trading partners and assist in order matching, but does not guarantee order execution.</li>
      </ul>
    `,
    security: 'Security and API Keys',
    securityContent: `
      <p>When you use API keys, ensure that they are kept secure during both storage and transmission. Publicly exposing your credentials can result in your account being compromised, which could lead to unexpected charges on your account. To help keep your API keys secure, follow these best practices:</p>
      <ul class="ol">
        <li>To help keep your API keys secure, follow these best practices:</li>
        <li>We recommend setting up API key IP Whitelist</li>
        <li>Delete unneeded API keys</li>
        <li>Regenerate your API keys periodically</li>
      </ul>
      <p>Greeks.live and its applications do not store any of your API keys info. You are solely responsible for keeping your API keys safe during usage.</p>
    `,
    dataCollection: 'Information Collection and Use',
    dataCollectionContent: `
      <p>We collect and process:</p>
      <ul class="ol">
        <li>Account registration information</li>
        <li>Device and technical information</li>
        <li>Trading and position data</li>
        <li>Operation logs and browser data</li>
      </ul>
    `,
    howToUse: 'How We Use Your Information',
    howToUseContent: `
      <ul class="ol">
        <li>Providing trading and account services</li>
        <li>Improving user experience</li>
        <li>Meeting legal obligations</li>
        <li>Sending service updates and marketing emails</li>
      </ul>
    `,
    dataSecurity: 'Data Protection and Security',
    dataSecurityContent: `
       <ul class="ol">
        <li>We implement reasonable security measures</li>
        <li>Your personal information is protected from unauthorized access</li>
        <li>We use cookies for service optimization</li>
        <li>You can manage cookie preferences</li>
      </ul>
    `,
    fees: 'Service Fees',
    feesContent: `
      <p>For RFQ trading services:</p>
      <ul class="ol">
        <li>The platform will transmit orders and execution to Deribit and other exchanges</li>
        <li>Greeks.live only provides assistance in order matching</li>
        <li>Trading fees will be specified in the announcement of the corresponding exchange</li>
        <li>Greeks.live does not charge any middle fees</li>
      </ul>
    `,
    risks: 'Risk Warning',
    risksContent: `
      <ul class="ol">
        <li>The cryptocurrency market has high risk, and you should fully understand and take responsibility for any potential risks and losses.</li>
        <li>Greeks.live does not assume any responsibility for any direct or indirect losses that users may suffer due to the use of the platform service.</li>
        <li>The platform cannot ensure that orders can be executed.</li>
      </ul>
    `,


    updates: 'Updates and Modifications',
    updatesContent: `
      <ul class="ol">
        <li>We reserve the right to update this agreement.</li>
        <li>Continued use of our services constitutes acceptance of modifications.</li>
        <li>The platform has the final interpretation of this agreement.</li>
      </ul>
    `,
    contact: 'Contact',
    contactContent: `
        <p>For questions or support: <a href="mailto:support@greeks.live" target="_blank" style="color: #606266; text-decoration: none;" >support@greeks.live</a></p>
    `
  },
  disclaimer: 'Disclaimer',
}

const en = {
  message: message,
}

export default en
